import StubPage from '../../components/StubPage.jsx';

export default function MonetizationPage() {
  return (
    <StubPage
      title="Monetization & business tools"
      description="Memberships, courses, bookings, invoicing, and affiliates."
      planned={[
        'Membership tiers with gated content',
        'Online courses with lessons, modules, and progress tracking',
        'Booking and scheduling with calendar sync',
        'Branded invoice generation + recurring billing',
        'Affiliate links with attribution and payouts',
      ]}
    />
  );
}
